class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.summary = this.mainDetailsToggle.querySelector("summary");
    this.megamenu = this.querySelector(".menu-drawer__megamenu");

    this.closeTimer = null;
    this.closeDelay = 100;

    this.summary.addEventListener("mouseenter", this.open.bind(this));
    this.megamenu?.addEventListener("mouseenter", this.cancelClose.bind(this));

    this.mainDetailsToggle.addEventListener(
      "mouseleave",
      this.scheduleClose.bind(this)
    );
    this.megamenu?.addEventListener(
      "mouseleave",
      this.scheduleClose.bind(this)
    );

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.summary.addEventListener("click", (e) => e.preventDefault());
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 100);
  }

  open() {
    clearTimeout(this.closeTimer);
    this.mainDetailsToggle.setAttribute("open", "");
    this.summary.setAttribute("aria-expanded", true);
  }

  scheduleClose() {
    this.closeTimer = setTimeout(() => {
      this.close();
    }, this.closeDelay);
  }

  cancelClose() {
    clearTimeout(this.closeTimer);
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.summary.setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);
